import pegasus from "../../assets/scripts/global/01-pegasus";

document.addEventListener("alpine:init", () => {
    Alpine.data("navigation", () => ({
        scrolled: false,
        visible: true,
        lastScrollTop: 0,
        isMobile: true,
        loaded: false,
        hasTransparentBg: false,
        menuOpen: false,
        init() {
            this.hasTransparentBg = this.$refs.navBar.classList.contains(
                "bg-navbar-transparent",
            );

            pegasus.onResizeFinished(() => {
                this.isMobile = window.outerWidth <= 1080;

                const page = document.getElementById("content");

                if (this.hasTransparentBg === false) {
                    if (this.isMobile) {
                        page.style.paddingTop = "72px";
                    } else {
                        page.style.paddingTop = "80px";
                    }
                }
            }, true);
        },
        lockScroll() {
            document.getElementsByTagName("body")[0].style.overflow = "hidden";
        },
        unlockScroll() {
            document.getElementsByTagName("body")[0].style.overflow = "auto";
        },
        menuScrolling() {
            const navigationContainer =
                    document.getElementById("page-nav-container"),
                navigationHeight = navigationContainer.offsetHeight;

            this.scrolled = window.scrollY >= navigationHeight;

            let st = window.scrollY;

            if (st >= this.lastScrollTop) {
                //Scroll Down
                if (st >= navigationHeight) {
                    //navigationContainer.classList.add("-translate-y-full");
                    //this.visible = false;
                } else {
                    //navigationContainer.classList.remove("-translate-y-full");
                    //this.visible = true;
                }
            } else {
                //Scroll Up
                navigationContainer.classList.remove("-translate-y-full");
                this.visible = true;
            }

            this.lastScrollTop = st;

            this.hasTransparentBg = this.$refs.navBar.classList.contains(
                "bg-navbar-transparent",
            );
        },
        navZedTop() {
            document.getElementById("page-header").classList.toggle("z-[5000]");
            document.getElementById("page-header").classList.toggle("z-[9999]");
        },
        openNav() {
            if (this.menuOpen) {
                this.closeNav();
            } else {
                this.menuOpen = true;
                this.lockScroll();
            }
        },
        closeNav() {
            this.menuOpen = false;
            this.unlockScroll();
        },
        handleOpenNav() {
            this.openNav();
        },
    }));
});
